'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('adminCACMControllers')
    .factory('adminCACMService', ['$http', '$q', function ($http) {

        var baseUrl = environment.apiUrl + '/Pilot/api/CACM';
        var service = {};

        service.synchronizeAllForIndexing = function () {
            var reqUrl = baseUrl + '/ReIndexing/Synchronize';

            return $http.post(reqUrl).then(function (response) { return response.data; });
        };

        service.getReIndexingSummary = function () {
            var reqUrl = baseUrl + '/ReIndexing/Summary';

            return $http.get(reqUrl).then(function (response) { return response.data; });
        };

        return service;

    }]);
